<template>
    <div>
        <a-form-model layout="inline" :labelAlign="labelAlign" :rules="rules" :model="buyer" ref="buyerForm" class="underline_input_form">
            <div class="info_item_box">
                <div class="header_box">
                    <div class="flex_v_center">
                        <img src="~@/assets/images/basic/ic_buyer.png" width="26px" height="26px">
                        <span class="info_title">下单人信息</span>
                    </div>
                </div>
                <div class="info_content">
                    <a-row type="flex">
                        <a-col flex="1">
                            <a-form-model-item label="姓名" prop="name">
                                <a-input v-model="buyer.name" placeholder="请输入姓名" />
                            </a-form-model-item>
                        </a-col>
                        <a-col flex="1" :offset="2">
                            <a-form-model-item label="手机号码" prop="mobile">
                                <a-input v-model="buyer.mobile" placeholder="请输入手机号码" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </div>
            </div>
        </a-form-model>
    </div>
</template>

<script>
export default {
    name: 'BuyerForm',
    model: {
        prop: 'buyer',
        event: 'change'
    },
    props: {
        buyer: {
            type: Object,
            required: true
        },
        labelAlign: {
            type: String,
            required: false,
            default: 'left'
        }
    },
    data () {
        return {
        rules: {
            name: [
                { required: true, message: '请输入下单人姓名', trigger: 'change' }
            ],
            mobile: [
                { required: true, message: '请输入下单人手机号码', trigger: ['blur', 'change'] },
                { validator: this.$validate.mobile, trigger: ['blur', 'change'] }
            ],
        }
        }
    },
    methods: {
        validate () {
            return new Promise((resolve, reject) => {
                this.$refs.buyerForm.validate(valid => {
                    if (valid) {
                        resolve()
                    } else {
                        reject(new Error('buyerForm has error'))
                    }
                })
            })
        }
    }
}
</script>

<style scoped>
.info_item_box .header_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    padding-right: 25px;
    background: #fafafa;
}

.info_item_box .info_title {
    font-size: 16px;
    margin-left: 10px;
}
.header_right_label {
    margin-left: 5px;
    font-size: 15px;
    cursor: pointer;
}
.info_content {
    padding: 25px 10px;
}

/* .info_item_box >>> .ant-form-item {
    width: 100%;
} */

.info_item_box >>> .ant-row:nth-child(n + 2) {
    margin-top: 35px;
}

::v-deep .ant-alert-warning {
    background-color: transparent;
}
::v-deep .ant-alert-message,
::v-deep .ant-alert-warning .ant-alert-icon {
    color: #ff1a36;
}

::v-deep .ant-btn {
    min-width: 40px;
    padding: 0 10px;
}
.ml15 {
    margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/order/BuyerForm.vue